import React, { useState, useEffect } from 'react'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { useParams } from 'react-router-dom'

const View = () => {
  const { id } = useParams()
  const [library, setLibrary] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchLibraryData = async () => {
    try {
      const response = await axiosAuthInstance.get(`library/detail/${id}`)
      setLibrary(response.data.result)
    } catch (error) {
      console.error('Error fetching library data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchLibraryData()
  }, [id])

  if (loading) return <div className='text-center py-4'>Loading...</div>
  if (!library) return <div className='text-center py-4'>No Library data found.</div>

  const imageKeys = ['Master', 'Specular', 'Reflection', 'Lighting', 'Extratex']

  return (
    <div className='p-2'>
      <div className='text-black rounded-lg p-4'>
        <h2 className='text-2xl font-semibold mb-4'>Library Details</h2>

        <table className='w-full'>
          <tbody>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Company Name</td>
              <td className='border-b px-4 py-2'>{library.company?.name}</td>
            </tr>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Library Category</td>
              <td className='border-b px-4 py-2'>{library.category?.name}</td>
            </tr>
          </tbody>
        </table>

        <h3 className='text-xl font-semibold mt-6 mb-4'>Images</h3>
        <div className='grid grid-cols-2 md:grid-cols-3 gap-6'>
          {imageKeys.map((key) => {
            const imageUrl = library.RoomData?.[key]
            return imageUrl ? (
              <div key={key} className='p-4 bg-gray-100 rounded-lg shadow-md'>
                <img
                  src={imageUrl}
                  alt={`${key} Image`}
                  className='w-full h-48 object-cover rounded-lg'
                />
                <div className='mt-4 text-sm text-gray-700'>
                  <p className='font-semibold'>{key}</p>
                  <p className='mt-1'>
                    <strong>Image Size:</strong>
                    <span className='ml-2'>
                      Width: {library.RoomData.ImageSize?.width} px, Height: {library.RoomData.ImageSize?.height} px
                    </span>
                  </p>
                </div>
              </div>
            ) : null
          })}
        </div>

        <h3 className='text-xl font-semibold mt-6 mb-4'>Room Coordinates</h3>
        {library.RoomData?.RoomCoordinate?.length > 0 ? (
          <ul className='space-y-4'>
            {library.RoomData.RoomCoordinate.map((coord, idx) => (
              <li key={coord._id || idx} className='bg-white p-4 rounded-lg shadow'>
                <p className='font-semibold'>Name: {coord.name}</p>
                <p>
                  <strong>Position:</strong> X: {coord.position?.x ?? 0}, Y: {coord.position?.y ?? 0}, Z: {coord.position?.z ?? 0}
                </p>
                <p>
                  <strong>Rotation:</strong> X: {coord.rotation?.x ?? 0}, Y: {coord.rotation?.y ?? 0}, Z: {coord.rotation?.z ?? 0}
                </p>
                <p>
                  <strong>Scale:</strong> X: {coord.scale?.x ?? 1}, Y: {coord.scale?.y ?? 1}, Z: {coord.scale?.z ?? 1}
                </p>
              </li>
            ))}
          </ul>
        ) : (
          <p className='text-center text-gray-500'>No Room Coordinates available</p>
        )}
      </div>
    </div>
  )
}

export default View
